module.exports = __webpack_public_path__ + "6e9d7bc712d654c6760d6d14aeda0a73.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/ABCMonumentGrotesk-Regular.woff2
// module id = 378
// module chunks = 0